import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'

const About = () => {
  const experienceRefs = useRef([])

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const numberElement = entry.target.querySelector('.experience-number')
          const finalValue = numberElement.textContent
          animateNumber(numberElement, finalValue)
          observer.unobserve(entry.target)
        }
      })
    })

    experienceRefs.current.forEach(ref => {
      if (ref) observer.observe(ref)
    })

    return () => observer.disconnect()
  }, [])

  const animateNumber = (element, finalValue) => {
    const duration = 2000
    const startTime = performance.now()
    const startValue = 0
    const endValue = parseInt(finalValue.replace(/\D/g, ''))
    
    function updateNumber(currentTime) {
      const elapsed = currentTime - startTime
      const progress = Math.min(elapsed / duration, 1)
      
      // Easing function for smoother animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4)
      
      const currentValue = Math.floor(startValue + (endValue - startValue) * easeOutQuart)
      element.textContent = currentValue + (finalValue.includes('+') ? '+' : '')
      
      if (progress < 1) {
        requestAnimationFrame(updateNumber)
      }
    }
    
    requestAnimationFrame(updateNumber)
  }

  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">درباره من</h2>
        <div className="about-content">
          <div className="about-text">
            <h3>سفر آموزشی من</h3>
            <p>
              بیش از ۲۰ سال سابقه تدریس در مدارس ، آموزشگاه و کلاس های خصوصی حضوری و آنلاین. در طول این سال ها صد ها دانش‌آموز را در سطوح مختلف آموزش داده ام و بزرگ ترین هدفم یادگیری ریاضی با عشق و لذت بوده است.
            </p>
            <p>
              فلسفه آموزشی من بر پایه درک عمیق مفاهیم، حل مسئله خلاقانه و ایجاد اعتماد به نفس در دانش‌آموزان استوار است. معتقدم که هر دانش‌آموزی قابلیت یادگیری ریاضی را دارد.
            </p>
            
            <div className="about-buttons">
              <Link to="/about" className="btn btn-primary">بیشتر بدانید</Link>
            </div>
            <div className="experience-grid">
              <div 
                ref={el => experienceRefs.current[0] = el}
                className="experience-item card-base card-light-sweep card-overlay"
              >
                <div className="experience-number">+20</div>
                <div className="experience-label">سال تجربه</div>
              </div>
              <div 
                ref={el => experienceRefs.current[1] = el}
                className="experience-item card-base card-light-sweep card-overlay"
              >
                <div className="experience-number">+500</div>
                <div className="experience-label">دانش‌آموز موفق</div>
              </div>
              <div 
                ref={el => experienceRefs.current[2] = el}
                className="experience-item card-base card-light-sweep card-overlay"
              >
                <div className="experience-number">+10</div>
                <div className="experience-label">حوزه تخصصی</div>
              </div>
            </div>
          </div>
          <div className="about-image">
            <div className="about-placeholder">
              <img 
                src="/images/teacher2.webp" 
                alt="سمیه ارباب مجنی در حال تدریس" 
                className="about-profile-image" 
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About 